module.exports = __webpack_public_path__ + "static/media/steak goosht.72db5dac.png";